// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__NjMd5","header":"footer_header__NpNKk","social-networks":"footer_social-networks__yVd+3","gradient-white":"footer_gradient-white__LCfPK"};